module.exports = __webpack_public_path__ + "img/discover.0217a452.png";